<div class="row">
    <div class="col">
        <div
            class="menu-entry cursor-pointer py-2 ps-3 pe-2"
            (click)="model.action()"
            [ngClass]="{ disabled: model.disabled }"
        >
            @if (model.icon) {
                <fa-icon class="me-2" [icon]="model.icon"></fa-icon>
            }
            {{ model.title }}
        </div>
    </div>
</div>
